"use client";

import type * as React from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster(props: ToasterProps) {
  return (
    <div
      className="pointer-events-none"
      onPointerDownCapture={(event) => {
        if (event.target instanceof Element && event.target.closest("[data-sonner-toast]")) {
          event.stopPropagation();
        }
      }}
      onClick={(event) => {
        if (event.target instanceof Element && event.target.closest("[data-sonner-toast]")) {
          event.stopPropagation();
        }
      }}
    >
      <Sonner
        className="toaster group pointer-events-none"
        closeButton
        position="top-center"
        richColors
        toastOptions={{
          classNames: {
            toast:
              "group toast pointer-events-auto group-[.toaster]:border-border group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:shadow-xl",
            closeButton: "pointer-events-auto",
            description: "group-[.toast]:text-muted-foreground group-[.toast]:leading-6",
            actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          },
        }}
        {...props}
      />
    </div>
  );
}

export { Toaster };
